export default __webpack_public_path__ + "static/media/northern_lights3.b9df2d87.webp";